export {default} from './JumboContentLayoutMain';